import { FormEventHandler } from '../form/events/form_event_handler';
import { ActivityFormEventHandler } from '../process/events/activity_form_event_handler';
import { FlashMessagesEventHandler } from '../flash_message/events/flash_messages_event_handler';
import { InputDocumentEventHandler } from '../document/events/input_document_event_handler';
import { ModalEventHandler } from '../modal/events/modal_event_handler';
import { AuthorizationEventHandler } from '../authorization/events/authorization_event_handler'

import { getDocumentHeight } from '../utils/dom_utils';

export default class EventHandlerPostMessageProxy {

	static init() {
		FormEventHandler.subscribeToAll(this.postMessageEventPublisher);
		ActivityFormEventHandler.subscribeToAll(this.postMessageEventPublisher);
		FlashMessagesEventHandler.subscribeToAll(this.postMessageEventPublisher);
		InputDocumentEventHandler.subscribeToAll(this.postMessageEventPublisher);
		ModalEventHandler.subscribeToAll(this.postMessageEventPublisher);
		AuthorizationEventHandler.subscribeToAll(this.postMessageEventPublisher);
	}

	static postMessageEventPublisher(event, ...args) {
		const jsonArgs = JSON.parse(JSON.stringify(args));
		const parentWindow = window.parent;
		if(!parentWindow) {
			return;
		}

		parentWindow.postMessage({
			event: event,
			data: jsonArgs,
			formHeight: getDocumentHeight()
		}, '*');
	}
}
